import { render, staticRenderFns } from "./Cog.vue?vue&type=template&id=20d4e1e6&"
import script from "./Cog.vue?vue&type=script&lang=js&"
export * from "./Cog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports